/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { DiagnosticReportPayload } from "../../models/diagnostic-report-payload";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReportDiagnostics_1$Params {
  customer_id?: string | null;
  body: DiagnosticReportPayload;
}

export function reportDiagnostics_1(
  http: HttpClient,
  rootUrl: string,
  params: ReportDiagnostics_1$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<null>> {
  const rb = new RequestBuilder(rootUrl, reportDiagnostics_1.PATH, "post");
  if (params) {
    rb.query("customer_id", params.customer_id, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<null>;
    }),
  );
}

reportDiagnostics_1.PATH = "/dashboard/user/diagnostic-report/";
